/* eslint-disable max-len */
/* eslint-disable react/no-danger, react/forbid-prop-types */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import classnames from 'classnames';
import { getLongFromShortCode } from '@homeaway/google-address-parser';
import Hero from '../../AEM/Hero';
import BrandLogos from '../../AEM/BrandLogos';
import BrandLogosV2 from '../../AEM/BrandLogos/BrandLogosV2';
import ColumnPanel from '../../AEM/ColumnPanel';
import ReadyToList from '../../AEM/ReadyToList';
import ReadyToListV2 from '../../AEM/ReadyToList/ReadyToListV2';
import FAQs from '../../FAQs';
import VrboFAQs from '../../VrboFAQs';
import EgFAQs from '../../EgFAQs';
import AppActions from '../../../actions/app';
import LocationActions from '../../../actions/location';
import LeadActions from '../../../actions/lead';
import TranslationUtil from '../../../utils/TranslationUtil';
import {
    getVacasaVariant,
    isVideoTestimonialsActive
} from '../../../utils/ExperimentsUtil';
import ExperimentUtil from '../../../utils/ExperimentUtil';
import VacasaComponent from '../../PropertyManagment/VacasaComponent';
import EgHeader from '../../EgHeader';
import EgFooter from '../../EgFooter';
import VrboHeader from '../LypHeader';
import VrboFooter from '../../Footer';
import MediaText from '../../MediaText/MediaText';
import HowItWorks from '../../HowItWorks';
import brandLogos from '../../AEM/BrandLogos/carousel_logos';

export const AemTemplate = ({
    children,
    history,
    referrer,
    hero,
    content: sectionsContent,
    isFrboFlow,
    vacasaProps,
    isVacasaViewed,
    setVacasaViewed,
    isModalOpen,
    vacasaVariant,
    firstName,
    firstNameValidation,
    setFirstName,
    lastName,
    lastNameValidation,
    setLastName,
    email,
    setEmail,
    address,
    countryList,
    addressValidation,
    getTranslation,
    brand,
    locale,
    setAddressField,
    phoneValidation,
    emailValidation,
    emailValidationErrorText,
    validateEmail,
    phoneNumber,
    phoneCountryCodeDigits,
    isVideoTestimonial,
    videoTestimonialProps,
    isRebranded,
    displayBrand
}) => {
    const ReadyToListComponent = !isRebranded ? ReadyToList : ReadyToListV2;
    const BrandLogosComponent = !isRebranded ? BrandLogos : BrandLogosV2;

    // eslint-disable-next-line no-nested-ternary
    const FAQsComponent = isRebranded ? FAQs : isFrboFlow ? VrboFAQs : EgFAQs;


    const [showVacasa, setShowVacasa] = useState(false);
    const [vacasaStep, setVacasaStep] = useState(1);

    const vacasaComponentProps = {
        ...vacasaProps,
        open: showVacasa,
        setShowVacasa,
        isVacasaViewed,
        isFrboFlow,
        isModalOpen,
        setVacasaViewed,
        firstName,
        firstNameValidation,
        setFirstName,
        lastName,
        lastNameValidation,
        setLastName,
        email,
        setEmail,
        address,
        countryList,
        addressValidation,
        getTranslation,
        brand,
        locale,
        setAddressField,
        phoneValidation,
        emailValidation,
        emailValidationErrorText,
        validateEmail,
        vacasaStep,
        setVacasaStep,
        vacasaVariant,
        phoneNumber,
        phoneCountryCodeDigits
    };

    const rebrandValuePropsColumns = {
        eg: [
            {
                index: 1,
                head: getTranslation('rebrand.eg.valueProps.column1.head'),
                body: getTranslation('rebrand.eg.valueProps.column1.body'),
                image: {
                    url: 'https://headless.expediagroup.com/content/dam/marketing/headless/images/home-page/EG_Icons-01_new_branding.png',
                    alt: ''
                }
            },
            {
                index: 2,
                head: getTranslation('rebrand.eg.valueProps.column2.head'),
                body: getTranslation('rebrand.eg.valueProps.column2.body'),
                image: {
                    url: 'https://headless.expediagroup.com/content/dam/marketing/headless/images/home-page/EG_Icons-02_new_branding.png',
                    alt: ''
                }
            },
            {
                index: 3,
                head: getTranslation('rebrand.eg.valueProps.column3.head'),
                body: getTranslation('rebrand.eg.valueProps.column3.body'),
                image: {
                    url: 'https://headless.expediagroup.com/content/dam/marketing/headless/images/home-page/EG_Icons-03_new_branding.png',
                    alt: ''
                }
            }
        ],
        vrbo: [
            {
                index: 1,
                head: getTranslation('rebrand.vrbo.valueProps.column1.head'),
                body: getTranslation('rebrand.vrbo.valueProps.column1.body', { brand: displayBrand }),
                image: {
                    url: 'https://headless.expediagroup.com/content/dam/marketing/headless/images/home-page/VR-icon-01_new_branding.png',
                    alt: ''
                }
            },
            {
                index: 2,
                head: getTranslation('rebrand.vrbo.valueProps.column2.head'),
                body: getTranslation('rebrand.vrbo.valueProps.column2.body'),
                image: {
                    url: 'https://headless.expediagroup.com/content/dam/marketing/headless/images/home-page/VR-icon-02_new_branding.png',
                    alt: ''
                }
            },
            {
                index: 3,
                head: getTranslation('rebrand.vrbo.valueProps.column3.head'),
                body: getTranslation('rebrand.vrbo.valueProps.column3.body'),
                image: {
                    url: 'https://headless.expediagroup.com/content/dam/marketing/headless/images/home-page/Vr-icon-03_new_branding.png',
                    alt: ''
                }
            }
        ]
    };

    const renderSections = [];
    if (isFrboFlow) {
        renderSections.push(
            <ReadyToListComponent
            // eslint-disable-next-line react/prop-types
                {...sectionsContent.readyToList.data}
                isFrboFlow={isFrboFlow}
                loginPrompt={getTranslation('Vrbo.lyp.rtl.login')}
            />
        );
    }

    renderSections.push(
        <ColumnPanel
            // eslint-disable-next-line react/prop-types
            {...sectionsContent.valueProps.data}
            columns={isRebranded
                ? rebrandValuePropsColumns[isFrboFlow ? 'vrbo' : 'eg']
                // eslint-disable-next-line react/prop-types
                : sectionsContent.valueProps.data.columns
            }
            variant="V2"
            id="Learn-more"
        />
    );
    renderSections.push(
        <BrandLogosComponent
            // eslint-disable-next-line react/prop-types
            {...sectionsContent.brandLogos.data}
            brandLogos={brandLogos}
        />
    );
    renderSections.push(<HowItWorks />);
    if (vacasaVariant === 2) {
        renderSections.push(
            <section className={classnames('ulx-property-managment')}>
                <VacasaComponent
                    {...vacasaComponentProps}
                />
            </section>
        );
    }
    if (isVideoTestimonial) {
        renderSections.push(<MediaText
            {...videoTestimonialProps}
        />);
    } else {
        renderSections.push(
            <ColumnPanel
                // eslint-disable-next-line react/prop-types
                {...sectionsContent.learnMore.data}
                id="Testimonials"
            />
        );
    }

    renderSections.push(<FAQsComponent />);

    if (!isFrboFlow) {
        renderSections.push(
            <ReadyToListComponent
            // eslint-disable-next-line react/prop-types
                {...sectionsContent.readyToList.data}
                isFrboFlow={isFrboFlow}
                loginPrompt={getTranslation('Vrbo.lyp.rtl.login')}
            />
        );
    }
    const Header = (!isFrboFlow) ? EgHeader : VrboHeader;
    const Footer = isFrboFlow ? VrboFooter : EgFooter;

    const classes = classnames('ulx-antialias',
        'ulx-aem-content-container',
        { 'ulx-aem-vr': isFrboFlow },
        { 'ulx-rebrand': isRebranded });

    return (
        <div className={classes}>
            {vacasaVariant !== 0
            && (
                <VacasaComponent
                    {...vacasaComponentProps}
                    isModal
                />
            )
            }
            <Header
                history={history}
                referrer={referrer}
                isRebranded={isRebranded}
                isFrboFlow={isFrboFlow}
            />
            <Hero
                {...hero}
                isFrboFlow={isFrboFlow}
                isRebranded={isRebranded}
            >
                {children}
            </Hero>
            {renderSections}
            <Footer showCompliance />
        </div>
    );
};

/* istanbul ignore next */
export const mapStateToProps = (state) => {
    const { app, lead, location } = state;
    const {
        aemData, features, isVacasaViewed, isModalOpen, brand, locale, displayBrand
    } = app;
    const {
        firstName, firstNameValidation, lastName, lastNameValidation, email, phoneValidation, emailValidation, phoneNumber, phoneCountryCodeDigits
    } = lead;
    const { address, addressValidation } = location;
    const { hero, content } = aemData;
    const { isFrboFlow } = features;
    const helpPhoneNumber = '1-888-539-6062';
    const experimentsUtil = new ExperimentUtil(app.experiments);
    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    const getTranslation = (translation, params = undefined) => translations.getTranslation(translation, params);
    const vacasaVariant = getVacasaVariant(experimentsUtil);
    const vacasaProps = {
        title: getTranslation('Vrbo.propertyManagement.vacasa.title'),
        description: getTranslation('Vrbo.propertyManagement.vacasa.description'),
        submitLabel: getTranslation('Vrbo.propertyManagement.vacasa.cta.submit'),
        closeLabel: getTranslation('modal.confirm'),
        firstNameLabel: getTranslation('lyp.leadForm.firstName.label'),
        lastNameLabel: getTranslation('lyp.leadForm.lastName.label'),
        emailLabel: getTranslation('lyp.leadForm.email.label'),
        leadFormTitle: getTranslation('Vrbo.propertyManagement.leadform.title'),
        leadFormDescription: getTranslation('Vrbo.propertyManagement.leadform.description'),
        leadFormSubmit: getTranslation('compLeadForm.requestACall'),
        leadFormPolicy: getTranslation('Vrbo.propertyManagement.leadform.policy'),
        successTitle: getTranslation('compLeadForm.successTitle'),
        successDescription: getTranslation('compLeadForm.successDesc'),
        successCta: getTranslation('compLeadForm.btnSubmit'),
        failureTitle: getTranslation('compLeadForm.failTitle'),
        failureDescription: getTranslation('Vrbo.propertyManagement.submission.failure.description', { phoneNumber: helpPhoneNumber }),
        failureCta: getTranslation('compLeadForm.fail.btnSubmit')
    };
    const countriesByCode = translations.mapCountryTranslations();
    const countryList = [
        'us',
        'ca',
        'mx',
        'bz',
        'cr'
    ].map(countryCode => ({
        text: countriesByCode[countryCode],
        value: countryCode.toUpperCase()
    }))
        // The phone list includes plaes that don't actually exist, so filter to countries with
        // actual valid ISO country codes
        .filter(item => !!getLongFromShortCode(item.value.toUpperCase()))
        .sort((a, b) => a.text.localeCompare(b.text));
    countryList.unshift({
        text: '--',
        value: ''
    });
    const isVideoTestimonial = isVideoTestimonialsActive(experimentsUtil);
    const videoTestimonialProps = isFrboFlow ? {
        headline: content.testimonials?.data?.headline ?? getTranslation('Vrbo.videoTestimonial.headline'),
        copy: content.testimonials?.data?.subheadline ?? getTranslation('Vrbo.videoTestimonial.copy'),
        mediaType: 'video',
        media: {
            url: 'IyjjPtwgT8s'
        },
        cta: {
            text: content.testimonials?.data?.cta ?? getTranslation('Vrbo.videoTestimonial.cta'),
            url: '#ulx-hero'
        },
        details: 'AEM VR video testimonial section',
        arrangement: 'right',
        ctaType: 'link'
    } : {
        headline: content.testimonials?.data?.headline ?? getTranslation('Classification.videoTestimonial.headline'),
        copy: content.testimonials?.data?.subheadline ?? getTranslation('Classification.videoTestimonial.copy'),
        mediaType: 'video',
        media: {
            url: 'wywuxdHLz38'
        },
        cta: {
            text: content.testimonials?.data?.cta ?? getTranslation('Classification.videoTestimonial.cta'),
            url: '#ulx-hero'
        },
        details: 'AEM VR video testimonial section',
        arrangement: 'right',
        ctaType: 'link'
    };


    return {
        hero,
        content,
        isFrboFlow,
        vacasaProps,
        isVacasaViewed,
        isModalOpen,
        vacasaVariant,
        firstName,
        firstNameValidation,
        lastName,
        lastNameValidation,
        email,
        address,
        countryList,
        addressValidation,
        getTranslation,
        brand,
        locale,
        phoneValidation,
        emailValidation,
        emailValidationErrorText: translations.getTranslation('validation.error.isValidEmail'),
        phoneNumber,
        phoneCountryCodeDigits,
        isVideoTestimonial,
        videoTestimonialProps,
        displayBrand
    };
};
const ValidationObject = {
    isValid: PropTypes.bool.isRequired,
    error: PropTypes.string
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch, ownProps) => ({
    setVacasaViewed: isViewed => dispatch(AppActions.setVacasaViewed(isViewed)),
    setFirstName: firstName => dispatch(LeadActions.setFirstName(firstName)),
    setLastName: lastName => dispatch(LeadActions.setLastName(lastName)),
    setEmail: email => dispatch(LeadActions.setEmail(email)),
    setAddressField:
    (fieldName, value) => {
        dispatch(LocationActions.setAddressField(fieldName, value,
            ownProps.features.isLatinInputEnabled, null));
    },
    validateEmail: email => dispatch(LeadActions.validateEmail(email, false, true))
});

AemTemplate.propTypes = {
    displayBrand: PropTypes.string.isRequired,
    videoTestimonialProps: PropTypes.shape({
        headline: PropTypes.string.isRequired,
        copy: PropTypes.string.isRequired,
        mediaType: PropTypes.string.isRequired,
        media: PropTypes.shape({
            url: PropTypes.string.isRequired,
            alt: PropTypes.string
        }).isRequired,
        cta: PropTypes.shape({
            text: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired
        }),
        details: PropTypes.string.isRequired,
        arrangement: PropTypes.string.isRequired,
        ctaType: PropTypes.string.isRequired
    }).isRequired,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]).isRequired,
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string
        }).isRequired
    }).isRequired,
    referrer: PropTypes.string.isRequired,
    hero: PropTypes.shape({}).isRequired,
    content: PropTypes.shape({
        readyToList: PropTypes.shape({}),
        valueProps: PropTypes.shape({}),
        vrImageText: PropTypes.shape({}),
        brandLogos: PropTypes.shape({}),
        learnMore: PropTypes.shape({}),
        faq: PropTypes.shape({})
    }).isRequired,
    isFrboFlow: PropTypes.bool.isRequired,
    isVideoTestimonial: PropTypes.bool.isRequired,
    isVacasaViewed: PropTypes.bool.isRequired,
    vacasaProps: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        closeLabel: PropTypes.string.isRequired,
        submitLabel: PropTypes.string.isRequired,
        firstNameLabel: PropTypes.string.isRequired,
        lastNameLabel: PropTypes.string.isRequired,
        emailLabel: PropTypes.string.isRequired,
        leadFormTitle: PropTypes.string.isRequired,
        leadFormDescription: PropTypes.string.isRequired,
        leadFormSubmit: PropTypes.string.isRequired,
        leadFormPolicy: PropTypes.string.isRequired,
        successTitle: PropTypes.string.isRequired,
        successDescription: PropTypes.string.isRequired,
        successCta: PropTypes.string.isRequired,
        failureTitle: PropTypes.string.isRequired,
        failureDescription: PropTypes.string.isRequired,
        failureCta: PropTypes.string.isRequired
    }).isRequired,
    setVacasaViewed: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    vacasaVariant: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    firstNameValidation: PropTypes.shape(ValidationObject).isRequired,
    setFirstName: PropTypes.func.isRequired,
    lastName: PropTypes.string.isRequired,
    lastNameValidation: PropTypes.shape(ValidationObject).isRequired,
    setLastName: PropTypes.func.isRequired,
    email: PropTypes.string.isRequired,
    setEmail: PropTypes.func.isRequired,
    address: PropTypes.shape({
        address1: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string,
        stateProvince: PropTypes.string,
        postalCode: PropTypes.string,
        country: PropTypes.string
    }).isRequired,
    countryList: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
    })).isRequired,
    addressValidation: PropTypes.shape({
        address1: PropTypes.shape({
            isValid: PropTypes.bool.isRequired,
            isSet: PropTypes.bool.isRequired,
            error: PropTypes.string,
            errorCode: PropTypes.string
        }),
        address2: PropTypes.shape({
            isValid: PropTypes.bool.isRequired,
            isSet: PropTypes.bool.isRequired,
            error: PropTypes.string,
            errorCode: PropTypes.string
        }),
        city: PropTypes.shape({
            isValid: PropTypes.bool.isRequired,
            isSet: PropTypes.bool.isRequired,
            error: PropTypes.string,
            errorCode: PropTypes.string
        }),
        stateProvince: PropTypes.shape({
            isValid: PropTypes.bool.isRequired,
            isSet: PropTypes.bool.isRequired,
            error: PropTypes.string,
            errorCode: PropTypes.string
        }),
        postalCode: PropTypes.shape({
            isValid: PropTypes.bool.isRequired,
            isSet: PropTypes.bool.isRequired,
            error: PropTypes.string,
            errorCode: PropTypes.string
        }),
        country: PropTypes.shape({
            isValid: PropTypes.bool.isRequired,
            isSet: PropTypes.bool.isRequired,
            error: PropTypes.string,
            errorCode: PropTypes.string
        })
    }).isRequired,
    getTranslation: PropTypes.func.isRequired,
    brand: PropTypes.string.isRequired,
    locale: PropTypes.shape({
        canonical: PropTypes.string,
        display: PropTypes.string
    }).isRequired,
    setAddressField: PropTypes.func.isRequired,
    phoneValidation: PropTypes.shape(ValidationObject).isRequired,
    emailValidation: PropTypes.shape(ValidationObject).isRequired,
    validateEmail: PropTypes.func.isRequired,
    emailValidationErrorText: PropTypes.string.isRequired,
    phoneCountryCodeDigits: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    isRebranded: PropTypes.bool.isRequired
};

export default hot(module)(connect(mapStateToProps, mapDispatchToProps)(AemTemplate));
